// extracted by mini-css-extract-plugin
export default {"burgerIcon":"BurgerIcon_burgerIcon__6LJ9T","active":"BurgerIcon_active__GTbpo"};